<template>
  <el-drawer
    :title="isDetail ? '详情' : '编辑'"
    :visible.sync="show"
    size="960px"
    append-to-body
    :wrapper-closable="false"
    custom-class="channel-reserve-edit-drawer"
  >
    <div class="drawer-body" v-loading="pageLoading">
      <div class="drawer-left">
        <div class="section-title">商品信息</div>
        <div v-if="reservation" class="product-preview">
          <div class="product-image">
            <el-image
              v-if="reservation.productMainImage"
              class="image"
              :src="reservation.productMainImage"
              fit="cover"
            />
            <img v-else src="../../../../../assets/images/default.png" class="image" />
          </div>
          <div class="product-title">{{ reservation.productName || '--' }}</div>
        </div>

      </div>

      <div class="drawer-right">
        <div class="form-section-title">约量信息提交</div>
        <el-form
          ref="formRef"
          :model="form"
          :rules="formRules"
          :validate-on-rule-change="false"
          label-width="120px"
          size="small"
        >
          <el-form-item label="约量渠道">
            <span class="readonly-text">{{ reservation && reservation.channelName || '--' }}</span>
            <!-- 渠道编辑暂不支持
            <el-popover
              v-model="channelPopoverVisible"
              placement="bottom-start"
              width="520"
              trigger="click"
              append-to-body
              popper-class="channel-select-popover"
              @show="handleChannelPopoverShow"
            >
              <div class="channel-select-panel">
                <el-input
                  v-model="channelSearchKeyword"
                  size="small"
                  clearable
                  placeholder="请输入渠道名称或手机号"
                  @keyup.enter.native="searchChannelList"
                  @clear="handleChannelSearchClear"
                >
                  <el-button slot="append" icon="el-icon-search" @click="searchChannelList" />
                </el-input>
                <el-table
                  :data="channelList"
                  v-loading="channelLoading"
                  size="small"
                  max-height="280"
                  class="channel-select-table"
                  @row-click="handleChannelRowClick"
                >
                  <el-table-column width="48" align="center" label="">
                    <template slot-scope="{ row }">
                      <el-radio
                        v-model="selectedChannelId"
                        :label="row.accountId"
                        class="channel-table-radio"
                        @change="handleChannelSelect(row)"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column prop="accountId" label="id" min-width="120" show-overflow-tooltip />
                  <el-table-column prop="nickName" label="渠道名称" min-width="120" show-overflow-tooltip />
                  <el-table-column prop="mobilePhone" label="手机号" min-width="120" show-overflow-tooltip />
                </el-table>
                <div class="channel-select-pagination">
                  <el-pagination
                    small
                    background
                    layout="total, prev, pager, next"
                    :total="channelPageInfo.total"
                    :page-size="channelPageInfo.size"
                    :current-page="channelPageInfo.current"
                    @current-change="handleChannelPageChange"
                  />
                </div>
              </div>
              <el-input
                slot="reference"
                readonly
                :value="channelDisplayText"
                placeholder="请选择"
                class="channel-select-input"
                @mousedown.native.prevent
                @focus.native="$event.target.blur()"
              >
                <template slot="suffix">
                  <i
                    v-if="selectedChannel"
                    class="el-input__icon el-icon-circle-close channel-input-clear"
                    @click.stop="clearChannel"
                  />
                  <i
                    class="el-input__icon el-icon-arrow-down channel-input-arrow"
                    :class="{ 'is-reverse': channelPopoverVisible }"
                  />
                </template>
              </el-input>
            </el-popover>
            -->
          </el-form-item>
          <el-form-item label="下单路径">
            <span class="readonly-text">{{ reservation && reservation.salesPathName || '--' }}</span>
          </el-form-item>
          <el-form-item label="所需库存">
            <span class="readonly-text">{{ reservationTypeLabel(form.reservationType) }}</span>
          </el-form-item>
          <el-form-item label="佣金">
            <span class="readonly-text">{{ commissionTypeLabel(form.commissionType) }}</span>
          </el-form-item>

          <el-form-item
            :label="form.reservationType === RESERVATION_TYPE.GMV ? '下单金额' : '下单数量'"
            prop="reservationAmount"
          >
            <span v-if="isDetail" class="readonly-text">
              {{ form.reservationAmount || '--' }}{{ form.reservationType === RESERVATION_TYPE.GMV ? '元' : '件' }}
            </span>
            <el-input
              v-else
              v-model="form.reservationAmount"
              :placeholder="form.reservationType === RESERVATION_TYPE.GMV ? '请输入下单金额' : '请输入下单数量'"
            >
              <template slot="append">{{ form.reservationType === RESERVATION_TYPE.GMV ? '元' : '件' }}</template>
            </el-input>
          </el-form-item>

          <el-form-item
            :label="form.commissionType === COMMISSION_TYPE.RATE ? '佣金比例' : '佣金金额'"
            prop="commissionValue"
          >
            <span v-if="isDetail" class="readonly-text">
              {{ form.commissionValue || '--' }}{{ form.commissionType === COMMISSION_TYPE.RATE ? '%' : '元/件' }}
            </span>
            <el-input
              v-else
              v-model="form.commissionValue"
              :placeholder="form.commissionType === COMMISSION_TYPE.RATE ? '请输入佣金比例' : '请输入佣金金额'"
            >
              <template slot="append">{{ form.commissionType === COMMISSION_TYPE.RATE ? '%' : '元/件' }}</template>
            </el-input>
          </el-form-item>

          <el-form-item label="预期下单时间" prop="expectedOrderTime">
            <span v-if="isDetail" class="readonly-text">{{ form.expectedOrderTime || '--' }}</span>
            <el-date-picker
              v-else
              v-model="form.expectedOrderTime"
              type="datetime"
              placeholder="请选择预期下单时间"
              style="width: 100%;"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="expectedOrderPickerOptions"
              @change="handleExpectedOrderTimeChange"
            />
          </el-form-item>

          <el-form-item label="备注">
            <span v-if="isDetail" class="readonly-text remark-text">{{ form.remark || '--' }}</span>
            <el-input
              v-else
              v-model="form.remark"
              type="textarea"
              :rows="4"
              maxlength="260"
              show-word-limit
              placeholder="请输入备注信息"
            />
          </el-form-item>
        </el-form>

        <div class="communicate-section">
          <div class="form-section-title">历史沟通记录</div>
          <el-table border stripe :data="changeLogList" v-loading="changeLogLoading" max-height="220">
            <el-table-column type="index" label="序号" width="60" />
            <el-table-column prop="operatorName" label="操作人" min-width="100" show-overflow-tooltip />
            <el-table-column prop="remark" label="备注内容" min-width="200" show-overflow-tooltip />
            <el-table-column prop="changeTime" label="操作时间" min-width="160" />
          </el-table>
        </div>
      </div>
    </div>

    <div class="drawer-footer">
      <el-button @click="show = false">返回</el-button>
      <template v-if="!isDetail">
        <el-button
          v-if="!isCompleted"
          :loading="confirmLoading"
          @click="handleConfirmComplete"
        >
          确认沟通完成
        </el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确定</el-button>
      </template>
    </div>
  </el-drawer>
</template>

<script>
import {
  getBizVolumeDetail,
  getBizVolumeChangeLogPage,
  updateBizVolume,
  confirmBizComplete
} from '@/service/apis/supVolume'
// import { channelPageList } from '@/service/apis/group'
import {
  RESERVATION_TYPE,
  COMMISSION_TYPE,
  formatEditChangeLogItem,
  reservationTypeLabel,
  commissionTypeLabel,
  reservationToEditForm,
  buildBizUpdatePayload,
  getBizEditFormRules,
  getExpectedOrderPickerOptions,
  validateVolumeForm
} from '@/page/component/sections/xpk/sup/sup-volume-fields'

export default {
  name: 'ChannelReserveEditDrawer',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: 'edit'
    }
  },
  data() {
    return {
      RESERVATION_TYPE,
      COMMISSION_TYPE,
      pageLoading: false,
      changeLogLoading: false,
      submitLoading: false,
      confirmLoading: false,
      reservation: null,
      changeLogList: [],
      // channelPopoverVisible: false,
      // channelSearchKeyword: '',
      // channelList: [],
      // channelLoading: false,
      // selectedChannelId: '',
      // selectedChannel: null,
      // channelPageInfo: {
      //   current: 1,
      //   size: 10,
      //   total: 0
      // },
      form: reservationToEditForm()
    }
  },
  computed: {
    formRules() {
      return getBizEditFormRules()
    },
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    isCompleted() {
      return !!(this.reservation && this.reservation.status === 3)
    },
    isDetail() {
      return this.mode === 'detail'
    },
    expectedOrderPickerOptions() {
      return getExpectedOrderPickerOptions(this.form.expectedOrderTime)
    }
    // channelDisplayText() {
    //   if (!this.selectedChannel) return ''
    //   const phone = this.selectedChannel.mobilePhone
    //   return phone
    //     ? `${this.selectedChannel.nickName}（${phone}）`
    //     : (this.selectedChannel.nickName || '')
    // }
  },
  watch: {
    value(val) {
      if (val) {
        this.loadDetail()
      }
    }
  },
  methods: {
    reservationTypeLabel,
    commissionTypeLabel,
    handleExpectedOrderTimeChange() {
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.validateField('expectedOrderTime')
      })
    },
    loadDetail() {
      if (!this.record || !this.record.id) {
        return
      }
      this.pageLoading = true
      getBizVolumeDetail.call(this, { id: this.record.id }).then(res => {
        this.reservation = {
          ...(res.reservation || {}),
          productMainImage: (res.reservation && res.reservation.productMainImage)
            || this.record.productMainImage
            || '',
          channelName: (res.reservation && res.reservation.channelName)
            || this.record.channelName
            || '',
          channelAccountId: (res.reservation && res.reservation.channelAccountId)
            || this.record.channelAccountId
            || ''
        }
        this.form = reservationToEditForm(this.reservation)
        // this.initChannelFromReservation(this.reservation)
        this.$nextTick(() => {
          this.$refs.formRef && this.$refs.formRef.clearValidate()
        })
        this.loadChangeLogList()
      }).finally(() => {
        this.pageLoading = false
      })
    },
    loadChangeLogList() {
      if (!this.record || !this.record.id) {
        this.changeLogList = []
        return
      }
      this.changeLogLoading = true
      getBizVolumeChangeLogPage.call(this, {
        reservationId: this.record.id,
        pageIndex: 1,
        pageSize: 100
      }).then(res => {
        const records = res.records || []
        this.changeLogList = records
          .map(formatEditChangeLogItem)
          .sort((a, b) => new Date(b.changeTime).getTime() - new Date(a.changeTime).getTime())
      }).finally(() => {
        this.changeLogLoading = false
      })
    },
    /* 渠道编辑暂不支持
    initChannelFromReservation(reservation = {}) {
      const accountId = reservation.channelAccountId != null && reservation.channelAccountId !== ''
        ? String(reservation.channelAccountId)
        : ''
      this.selectedChannelId = accountId
      this.selectedChannel = accountId ? {
        accountId,
        nickName: reservation.channelName || '',
        mobilePhone: reservation.channelMobilePhone || ''
      } : null
      this.channelPopoverVisible = false
      this.channelSearchKeyword = ''
      this.channelList = []
      this.channelPageInfo.current = 1
      this.channelPageInfo.total = 0
    },
    handleChannelPopoverShow() {
      if (!this.channelList.length) {
        this.getChannelList()
      }
    },
    searchChannelList() {
      this.channelPageInfo.current = 1
      this.getChannelList()
    },
    handleChannelSearchClear() {
      this.channelSearchKeyword = ''
      this.searchChannelList()
    },
    handleChannelPageChange(page) {
      this.channelPageInfo.current = page
      this.getChannelList()
    },
    getChannelList() {
      const params = {
        current: this.channelPageInfo.current,
        size: this.channelPageInfo.size
      }
      const queryString = (this.channelSearchKeyword || '').trim()
      if (queryString) {
        params.queryString = queryString
      }
      this.channelLoading = true
      return channelPageList.call(this, params).then(res => {
        this.channelList = res.records || []
        this.channelPageInfo.total = res.total || 0
      }).finally(() => {
        this.channelLoading = false
      })
    },
    handleChannelRowClick(row) {
      this.handleChannelSelect(row)
    },
    handleChannelSelect(row) {
      if (!row) return
      const accountId = row.accountId != null ? String(row.accountId) : ''
      this.selectedChannelId = accountId
      this.selectedChannel = row
      this.form.channelAccountId = accountId
      if (this.reservation) {
        this.reservation = {
          ...this.reservation,
          channelAccountId: accountId,
          channelName: row.nickName || ''
        }
      }
      this.channelPopoverVisible = false
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate(['channelAccountId'])
      })
    },
    clearChannel() {
      this.selectedChannelId = ''
      this.selectedChannel = null
      this.form.channelAccountId = ''
      if (this.reservation) {
        this.reservation = {
          ...this.reservation,
          channelAccountId: '',
          channelName: ''
        }
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.validateField('channelAccountId')
      })
    },
    */
    async handleSubmit() {
      if (!this.reservation) return
      const valid = await validateVolumeForm(this.$refs.formRef, this)
      if (!valid) return

      const doUpdate = (confirmEditCompleted = false) => {
        const payload = buildBizUpdatePayload({
          reservation: this.reservation,
          form: this.form,
          confirmEditCompleted
        })
        this.submitLoading = true
        return updateBizVolume.call(this, payload).then(() => {
          this.$message.success('保存成功')
          this.$emit('success')
          this.show = false
        }).finally(() => {
          this.submitLoading = false
        })
      }

      if (this.reservation.status === 3) {
        this.$confirm(
          '尊敬的用户你好，该条记录已标记为完成状态，是否继续编辑',
          '提示',
          {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
          }
        ).then(() => doUpdate(true)).catch(() => {})
        return
      }

      doUpdate(false)
    },
    async handleConfirmComplete() {
      if (!this.reservation || this.isCompleted) return
      const valid = await validateVolumeForm(this.$refs.formRef, this)
      if (!valid) return

      this.$confirm('确认沟通完成后，数据将同步至 SUP 部门，是否继续？', '提示', {
        type: 'warning'
      }).then(async () => {
        this.confirmLoading = true
        try {
          const payload = buildBizUpdatePayload({
            reservation: this.reservation,
            form: this.form,
            confirmEditCompleted: false
          })
          await updateBizVolume.call(this, payload)
          await confirmBizComplete.call(this, { id: this.reservation.id })
          this.$message.success('已确认沟通完成')
          this.$emit('success')
          this.show = false
        } finally {
          this.confirmLoading = false
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.drawer-body {
  display: flex;
  height: calc(100vh - 140px);
  padding: 0 20px;
  overflow: hidden;
}

.drawer-left {
  width: 320px;
  flex-shrink: 0;
  border-right: 1px solid #eee;
  padding-right: 20px;
  overflow-y: auto;
}

.section-title,
.form-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin: 16px 0;
}

.product-preview {
  flex-shrink: 0;
  margin-bottom: 12px;
}

.product-image {
  position: relative;
  width: 100%;
  padding-top: 100%;
  background-color: #f5f5f5;
  border-radius: 2px;
  overflow: hidden;
}

.product-image .image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-image .image ::v-deep .el-image__inner {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-title {
  margin-top: 12px;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: #333;
  text-align: center;
}

.drawer-right {
  flex: 1;
  padding-left: 24px;
  overflow-y: auto;
}

.readonly-text {
  color: #333;
  line-height: 32px;
}

.remark-text {
  line-height: 22px;
  white-space: pre-wrap;
  word-break: break-all;
}

.communicate-section {
  margin-top: 8px;
}

.drawer-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: auto;
  padding: 12px 24px;
  border-top: 1px solid #eee;
  background-color: #fff;
}

.drawer-footer ::v-deep .el-button {
  height: 32px;
  padding: 0 15px;
  line-height: 32px;
}

.drawer-footer .el-button + .el-button {
  margin-left: 12px;
}

/* 渠道编辑暂不支持
.channel-select-input {
  width: 100%;
  cursor: pointer;
}

.channel-select-input ::v-deep .el-input__inner {
  cursor: pointer;
}

.channel-input-arrow {
  transition: transform 0.3s;
}

.channel-input-arrow.is-reverse {
  transform: rotate(180deg);
}

.channel-input-clear {
  cursor: pointer;
}

.channel-input-clear:hover {
  color: #909399;
}

.channel-select-panel {
  padding: 4px 0 0;
}

.channel-select-table {
  margin-top: 10px;
}

.channel-select-table ::v-deep .channel-table-radio {
  margin-right: 0;
}

.channel-select-table ::v-deep .channel-table-radio .el-radio__label {
  display: none;
  padding-left: 0;
}

.channel-select-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
*/
</style>

<style>
.channel-reserve-edit-drawer .el-drawer__body {
  position: relative;
  padding-bottom: 60px;
}

/* .channel-select-popover {
  padding: 12px;
} */
</style>
